export default __webpack_public_path__ + "static/media/zip5.8b5e7b32.txt";